module.exports = __webpack_public_path__ + "assets/star-orange-c64262.svg";